define(['jquery', 'jquery.history'], function ($) {
    var take = 0;
    var page = 1;
    var type = '';
    var cid = '';
    var keyword = '';
    var isLoadMore = false;
    var currentIndex = 1;
    var totalInsightsFound = 0;
    var $resultListArea = $(".js-listing-module .articles-list");
    var results = [];

    // execute this once the DOMContentLoaded has fired (dom ready)
    $(function (context, targetEl, facadeEl) {
        $('.js-view-more').hide();
        take = parseInt($(".js-listing-module").attr("data-take"));

        type = getParameterByName('type');
        if (type == '') {
            type = $(".js-listing-module").attr("data-type");
        }

        //only need to update the cid history for back button on category pages
        cid = getParameterByName('cid');
        if (cid != '') { updateHistory({}, "cid", cid); }
        if (cid == '') {
            cid = $(".js-listing-module").attr("data-cid");
        }

        tid = getParameterByName('tid');
        if (tid == '') {
            tid = $(".js-listing-module").attr("data-tid");
        }

        keyword = getParameterByName('keyword');
        if (keyword && keyword != '') {
            $('.js-listing-module .js-keyword').val(keyword);
            $(".form-results__criteria").append('<span role="button" class="btn btn-grey form-results__keyword keyword-field">' + keyword + '</span>');
            BindRemoveCriteriaClick();
            updateHistory({}, "keyword", keyword);
        }

        GetSearchResults();
    }());

    function BindRemoveCriteriaClick() {
        $(".form-results__keyword").unbind();
        $(".form-results__keyword").click(function () {
            if ($(this).hasClass("keyword-field")) {
                resetSearch();
            }
        });
    }

    function escapeHtml(str) {
        var div = document.createElement('div');
        div.appendChild(document.createTextNode(str));
        return div.innerHTML;
    }

    function resetSearch() {
        $resultListArea.html('');
        $(".form-results__keyword.keyword-field").remove();
        $('.js-listing-module .js-keyword').val('');
        History.replaceState({}, "", removeQueryString(History.getState().url, "keyword", encodeURIComponent(keyword)));
        keyword = '';
        page = 1;
        GetSearchResults();
    }

    $(".js-listing-module .js-keyword").keypress(function (e) {
        if (e.which == 13) {
            page = 1;
            isLoadMore = false;
            $(".form-results__keyword.keyword-field").remove();
            keyword = $(this).val();
            if (keyword != "") {
                $(".form-results__criteria").append('<span role="button" class="btn btn-grey form-results__keyword keyword-field">' + keyword + '</span>');
                BindRemoveCriteriaClick();
            }
            updateHistory({}, "keyword", keyword);
            GetSearchResults();
            return false;
        }
    });

    $(".js-listing-module .js-keyword-btn").on('click', function (e) {
        keyword = $('.js-listing-module .js-keyword').val();
        if (keyword) {
            page = 1;
            isLoadMore = false;
            $(".form-results__keyword.keyword-field").remove();
            $(".form-results__criteria").append('<span role="button" class="btn btn-grey form-results__keyword keyword-field">' + keyword + '</span>');
            updateHistory({}, "keyword", keyword);
            GetSearchResults();
        }
    });

    $('.btn.readmore-trigger').on('click', function () {
        isLoadMore = true;        
        GetPaginatedSearchResults(currentIndex);
    });

    function GetSearchResults() {
        $(".loading-image").show();
        $.ajax({
            type: "POST",
            url: "/Layouts/WebUserControls/Main/Insights/InsightSearchService.asmx/GetListingResults",
            data: JSON.stringify({ type: type, categoryId: cid, topicId: tid, startPage: page, keyWord: keyword, skip: 0, take: take }),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (response) {
                results = JSON.parse(response.d).Insights;
                currentIndex = 1;
                totalInsightsFound = JSON.parse(response.d).TotalInsightsFound;

                $(".filtering__results").text("Result(s): " + totalInsightsFound);

                if (totalInsightsFound == 0) {
                    $(".loading-image").hide();
                }

                //clear previous search results if load more is false
                if (!isLoadMore) {
                    $resultListArea.html('');
                }

                LoadListItems(currentIndex)

                if (keyword !== '') {
                    $('.js-form-results').show();
                } else {
                    $('.js-form-results').hide();
                }

                $resultListArea.show();

                $(".filtering.filtering--result-stat").show();
            },
            error: function (xhr, ajaxOptions, thrownError) {

            }
        });
    }

    function GetPaginatedSearchResults() {
        $.ajax({
            type: "POST",
            url: "/Layouts/WebUserControls/Main/Insights/InsightSearchService.asmx/GetListingResults",
            data: JSON.stringify({ type: type, categoryId: cid, topicId: tid, startPage: page, keyWord: keyword, skip: currentIndex - 1, take: take }),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (response) {
                results = JSON.parse(response.d).Insights;
                currentIndex = currentIndex;
                totalInsightsFound = JSON.parse(response.d).TotalInsightsFound;

                LoadListItems(currentIndex)

                $(".filtering.filtering--result-stat").show();
            },
            error: function (xhr, ajaxOptions, thrownError) {

            }
        });
    }

    function LoadListItems(index) {
        if (index > totalInsightsFound || index >= (currentIndex + take)) {
            if (totalInsightsFound <= (page * take)) {
                $('.js-view-more').hide();
            } else {
                $('.js-view-more').show();
            }
            $(".loading-image").hide();

            currentIndex = index;
            page++;
            return;
        }

        var ajaxUrl = "/Layouts/WebUserControls/Main/Insights/AjaxLoadListItem.aspx?guid=" + results[(page > 1 ? (index - 1) - (take * (page - 1)) : index - 1)];
        $.ajax({ url: ajaxUrl })
            .done(function (p) {
                $resultListArea.append(p);
                $resultListArea.fadeIn();
                LoadListItems(index + 1)
                $(".loading-image").hide();
            });
    }

    //constructs url with query parameters
    function updateHistory(stateObj, dataType, dataGuid) {
        if (window.location.href.toString().indexOf("?") == -1) {
            History.pushState({}, document.title, "?" + dataType + "=" + encodeURIComponent(dataGuid));
        } else if (dataType == "keyword" && window.location.href.toString().indexOf("keyword") > -1) {
            if (dataGuid == "") {
                var currURL = History.getState().url;
                var keywordValue = getParameterByName("keyword");
                History.replaceState({}, document.title, removeQueryString(currURL, "keyword", encodeURIComponent(keywordValue)));
            } else {
                var currURL = History.getState().url;

                //get decoded keyword value
                var keywordValue = getParameterByName("keyword");
                var updatedKeywordQuery = History.getState().url.replace("keyword=" + encodeURIComponent(keywordValue), "keyword=" + encodeURIComponent(dataGuid));
                var newQueryString = removeQueryString(currURL, "keyword", encodeURIComponent(keywordValue));

                if (window.location.href.toString().indexOf("?keyword") > -1) {
                    History.replaceState({}, document.title, newQueryString + "?keyword=" + encodeURIComponent(dataGuid));
                } else {
                    History.replaceState({}, document.title, newQueryString + "&keyword=" + encodeURIComponent(dataGuid));
                }
            }
        } else if (window.location.href.toString().indexOf("?") > -1 && window.location.href.toString().indexOf(dataGuid) == -1) {
            History.replaceState({}, document.title, History.getState().url += "&" + dataType + "=" + encodeURIComponent(dataGuid));
        }
    }

    //finds current query parameter given a type to search for
    //for example, will return the keyword the user is searching for by parsing url for 'keyword'
    function getParameterByName(name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(location.search);
        return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }

    function removeQueryString(currURL, dataType, dataGuid) {
        var currQueryString = dataType + "=" + dataGuid;
        var queryStringBefore = "";
        var queryStringAfter = "";
        var host = "";
        var newQueryString = "";

        //index of question mark
        var qmIDX = currURL.indexOf("?");

        //subtract one to include ? or & char
        var startIDX = currURL.indexOf(currQueryString) - 1;

        //error catching
        //if ever a  query parameter is removed from the url, but not .form-results__criteria, then return nothing
        if (startIDX < 0) {
            return ""
        }

        var endIDX = currQueryString.length + startIDX + 1;

        queryStringBefore = currURL.substring(qmIDX, startIDX);
        host = currURL.substring(0, qmIDX);

        if (endIDX == currURL.length) {
            queryStringAfter = "";
        } else {
            queryStringAfter = currURL.substring(endIDX, currURL.length);
        }

        if (queryStringBefore == "" && queryStringAfter == "") {
            return host;
        } else {
            newQueryString = queryStringBefore + queryStringAfter;
            if (newQueryString.charAt(0) == "&") {
                newQueryString = newQueryString.replace("&", "?");
            }
            return newQueryString;
        }
    }
});